import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 4000 }
  }

  connect() {
    // Start entry animation
    requestAnimationFrame(() => {
      this.element.classList.remove('translate-x-full', 'opacity-0')
      this.element.classList.add('translate-x-0', 'opacity-100')
    })

    // Set auto-dismiss timer
    if (this.timeoutValue > 0) {
      this.timer = setTimeout(() => {
        this.close()
      }, this.timeoutValue)
    }
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  close() {
    // Start exit animation
    this.element.classList.remove('translate-x-0', 'opacity-100')
    this.element.classList.add('translate-x-full', 'opacity-0')

    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300) // matches duration-300 in Tailwind
  }
}
